'use client'

import Link from 'next/link'

import { ZEditorJsRenderer } from '@/_components/universal/editorjs-renderer'
import { useAccordion } from '@/_hooks/useAccordion'
import { IAnnualProgram, IPreventiveExamination } from '@/_types'

interface IProps {
	data: IPreventiveExamination | IAnnualProgram
	initialExpanded?: boolean
	/** Called when a single module checkbox toggles; supports multiple selected modules. */
	onModulesChange?: (module: any, isChecked: boolean) => void
	/** When set, checkboxes are controlled from parent state. */
	selectedModuleIds?: number[]
	className?: string
}

const AContentCardAddAdditional = ({
	data,
	initialExpanded = false,
	onModulesChange,
	selectedModuleIds = [],
	className
}: IProps) => {
	const { toggleAccordion, expandedClass } = useAccordion({
		initialExpanded,
		initialExpandedKey: 'additional'
	})

	const handleModuleChange = (module: any, isChecked: boolean) => {
		onModulesChange?.(module, isChecked)
	}

	if (!data.modules?.length) return null

	return (
		<div className={className ?? 'item_modul mgt-35 mgt-20lg'}>
			<div className='accord'>
				<div className={`item_accord accorditem py-1 ${expandedClass('additional')}`}>
					<Link
						href='#'
						title='Pridajte si voliteľné moduly'
						className='item_accord_head accordhead'
						onClick={toggleAccordion('additional')}
						prefetch={false}
					>
						<span>
							<strong>Pridajte si voliteľné moduly</strong>
						</span>
						<div className='circle'></div>
					</Link>

					<div className='item_accord_expand'>
						<div>
							<div className='item_accord_content'>
								<div className='page_content reset_margins'>
									<div className='text_s12 reset_margins mb-3'>
										<p>
											Pomocou voliteľných modulov si môžete
											<br />
											pridať k obsahu preventívnej prehliadky
											<br />
											ďalšie preventívne vyšetrenia.
										</p>
									</div>
									<ul>
										{data.modules.map(modul => (
											<li className='dflex justify-between' key={modul.id}>
												<label className='input_checkbox_cont flex-row!'>
													<input
														type='checkbox'
														value={modul.id}
														className='input_checkbox'
														checked={selectedModuleIds.includes(
															modul.id
														)}
														onChange={e =>
															handleModuleChange(
																modul,
																e.target.checked
															)
														}
													/>
													<div className='input_checkbox_text'>
														<strong>{modul.name}</strong>
														<br />

														<ZEditorJsRenderer
															data={modul.description}
															className='pb-2! pt-2! text-white **:text-white! text-[13px] **:text-[13px]!'
														/>
													</div>
												</label>
												<div className='price'>{modul.price} €</div>
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AContentCardAddAdditional
